import { v4 } from 'uuid';

/** @public */
var host;
(function (host) {
    (function (MatterTabs) {
        MatterTabs[MatterTabs["Matter"] = 0] = "Matter";
        MatterTabs[MatterTabs["Emails"] = 1] = "Emails";
        MatterTabs[MatterTabs["Events"] = 2] = "Events";
        MatterTabs[MatterTabs["Tasks"] = 3] = "Tasks";
        MatterTabs[MatterTabs["Timeline"] = 4] = "Timeline";
        MatterTabs[MatterTabs["InfoTrack"] = 5] = "InfoTrack";
        MatterTabs[MatterTabs["Communicate"] = 8] = "Communicate";
        MatterTabs[MatterTabs["Memos"] = 9] = "Memos";
        MatterTabs[MatterTabs["Activity"] = 10] = "Activity";
        MatterTabs[MatterTabs["Parenting"] = 11] = "Parenting";
        MatterTabs[MatterTabs["Property"] = 12] = "Property";
        MatterTabs[MatterTabs["MatterPerformance"] = 13] = "MatterPerformance";
        MatterTabs[MatterTabs["Intake"] = 14] = "Intake";
        MatterTabs[MatterTabs["FamilyProperty"] = 15] = "FamilyProperty";
    })(host.MatterTabs || (host.MatterTabs = {}));
})(host || (host = {}));

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

class HostApi {
    constructor(host) {
        this._host = host;
    }
    selectTab(tab) {
        const msg = {
            messageId: v4(),
            operation: 'host.selectTab',
            payload: tab
        };
        return this._host.browser.call(msg);
    }
    version() {
        const msg = this.createMessage('host.version', v4());
        return this._host.browser.callTwoWay(msg);
    }
    setCommands(request) {
        const msg = {
            messageId: v4(),
            operation: 'host.setCommands',
            payload: request
        };
        return this._host.browser.call(msg);
    }
    refresh() {
        const msg = this.createMessage('host.refresh', v4());
        return this._host.browser.call(msg);
    }
    open(request) {
        const msg = {
            messageId: v4(),
            operation: 'host.open',
            payload: request
        };
        return this._host.browser.call(msg);
    }
    modal(request) {
        const msg = {
            messageId: v4(),
            operation: 'host.modal',
            payload: request
        };
        return this._host.browser.callTwoWay(msg);
    }
    close(request) {
        const msg = {
            messageId: v4(),
            operation: 'host.close',
            payload: request
        };
        return this._host.browser.call(msg);
    }
    createMessage(operation, messageId) {
        const msg = {
            messageId: messageId,
            operation: operation
        };
        return msg;
    }
}

class AuthApi {
    constructor(host) {
        this._host = host;
    }
    token() {
        const msg = {
            messageId: v4(),
            operation: 'auth.token'
        };
        return this._host.browser.callTwoWay(msg);
    }
    idToken() {
        const msg = {
            messageId: v4(),
            operation: 'auth.idToken'
        };
        return this._host.browser.callTwoWay(msg);
    }
}

class MattersApi {
    constructor(host) {
        this._host = host;
    }
    create(request) {
        if (!request.clientIds) {
            throw Error('No clientId provided');
        }
        if (request.clientIds.length > 1) {
            throw Error('clientIds require exactly 1 ClientId. Support for adding multiple ClientIds will be added in future updates.');
        }
        if (!request.matterTypeId) {
            throw Error('No matterTypeId provided');
        }
        const msg = {
            messageId: v4(),
            operation: 'matters.create',
            payload: request
        };
        return this._host.browser.callTwoWay(msg);
    }
    get(matterId) {
        const msg = this.createMessage('matters.get', v4(), matterId);
        return this._host.browser.callTwoWay(msg);
    }
    getMany(request) {
        if (!request.ids) {
            throw Error('No MatterIds provided');
        }
        const msg = {
            messageId: v4(),
            operation: 'matters.getMany',
            payload: request
        };
        return this._host.browser.callTwoWay(msg);
    }
    observe(callback, matterId) {
        matterId = matterId !== null && matterId !== void 0 ? matterId : this._host.context.matterId;
        if (!matterId) {
            throw Error('MatterId is missing');
        }
        if (!callback) {
            throw Error('Callback is missing');
        }
        const request = {
            id: matterId,
            // Deprecated
            matterId: matterId
        };
        // Use the sessionId for the subscription to prevent multiple subscriptions per session
        const msg = {
            messageId: `matters_${this._host.context.sessionId}`,
            operation: 'matters.observe',
            payload: request
        };
        // Create the subscription here
        this._host.browser.subscribe(msg, callback);
    }
    open(matterId) {
        const msg = this.createMessage('matters.open', v4(), matterId);
        return this._host.browser.call(msg);
    }
    select() {
        const msg = {
            messageId: v4(),
            operation: 'matters.select'
        };
        return this._host.browser.callTwoWay(msg);
    }
    createMessage(operation, messageId, matterId) {
        matterId = matterId !== null && matterId !== void 0 ? matterId : this._host.context.matterId;
        if (!matterId) {
            throw Error('MatterId is missing');
        }
        const request = {
            id: matterId,
            // Deprecated
            matterId: matterId
        };
        const msg = {
            messageId: messageId,
            operation: operation,
            payload: request
        };
        return msg;
    }
}

class MatterItemsApi {
    constructor(host) {
        this._host = host;
    }
    get(matterId) {
        matterId = matterId !== null && matterId !== void 0 ? matterId : this._host.context.matterId;
        if (!matterId) {
            throw Error('MatterId is missing');
        }
        const request = {
            matterId: matterId
        };
        const msg = this.createMessage('matterItems.get', v4(), request);
        return this._host.browser.callTwoWay(msg);
    }
    createMessage(operation, messageId, request) {
        const msg = {
            messageId: messageId,
            operation: operation,
            payload: request
        };
        return msg;
    }
}

class RolesApi {
    constructor(host) {
        this._host = host;
    }
    get() {
        const request = {
            matterId: this._host.context.matterId
        };
        const msg = this.createMessage('roles.get', v4(), request);
        return this._host.browser.callTwoWay(msg);
    }
    add(request) {
        const msg = this.createMessage('roles.add', v4(), request);
        return this._host.browser.callTwoWay(msg);
    }
    update(request) {
        const msg = this.createMessage('roles.update', v4(), request);
        return this._host.browser.callTwoWay(msg);
    }
    remove(id) {
        const request = {
            id: id
        };
        const msg = this.createMessage('roles.remove', v4(), request);
        return this._host.browser.callTwoWay(msg);
    }
    observe(callback, matterId) {
        if (!callback) {
            throw Error('Callback is missing');
        }
        const request = {
            matterId: matterId
        };
        // Use the sessionId for the subscription to prevent multiple subscriptions per session
        const messageId = `roles_${this._host.context.sessionId}`;
        const msg = this.createMessage('roles.observe', messageId, request);
        // Create the subscription here
        this._host.browser.subscribe(msg, callback);
    }
    createMessage(operation, messageId, request) {
        const msg = {
            messageId: messageId,
            operation: operation,
            payload: request
        };
        return msg;
    }
}

class ContactsApi {
    constructor(host) {
        this._host = host;
    }
    get(contactId) {
        const request = {
            id: contactId,
            // Deprecated
            contactId: contactId
        };
        const msg = this.createMessage('contacts.get', v4(), request);
        return this._host.browser.callTwoWay(msg);
    }
    create(request) {
        const msg = this.createMessage('contacts.create', v4(), request);
        return this._host.browser.callTwoWay(msg);
    }
    update(request) {
        const msg = this.createMessage('contacts.update', v4(), request);
        return this._host.browser.callTwoWay(msg);
    }
    observe(callback) {
        // Use the sessionId for the subscription to prevent multiple subscriptions per session
        const messageId = `contacts_${this._host.context.sessionId}`;
        const msg = this.createMessage('contacts.observe', messageId);
        // Wrap the callback so we can hide the ContactsResponse from the user
        const callbackWrapper = (response) => {
            callback(response.contacts);
        };
        // Create the subscription here
        this._host.browser.subscribe(msg, callbackWrapper);
    }
    open(contactId) {
        const request = {
            id: contactId,
            // Deprecated
            contactId: contactId
        };
        const msg = this.createMessage('contacts.open', v4(), request);
        return this._host.browser.call(msg);
    }
    createMessage(operation, messageId, request) {
        const msg = {
            messageId: messageId,
            operation: operation,
            payload: request
        };
        return msg;
    }
}

class LayoutsApi {
    constructor(host) {
        this._host = host;
    }
    get(matterId) {
        matterId = matterId !== null && matterId !== void 0 ? matterId : this._host.context.matterId;
        if (!matterId) {
            throw Error('MatterId is missing');
        }
        const request = {
            matterId: matterId
        };
        const msg = this.createMessage('layouts.get', v4(), request);
        return this._host.browser.callTwoWay(msg);
    }
    getItem(itemId) {
        const request = {
            itemId
        };
        const msg = this.createMessage('layouts.getItem', v4(), request);
        return this._host.browser.callTwoWay(msg);
    }
    getContacts(itemId) {
        const request = {
            itemId: itemId
        };
        const msg = this.createMessage('layouts.getItemContacts', v4(), request);
        return this._host.browser.callTwoWay(msg);
    }
    update(request) {
        var _a;
        request.matterId = (_a = request.matterId) !== null && _a !== void 0 ? _a : this._host.context.matterId;
        const msg = this.createMessage('layouts.update', v4(), request);
        return this._host.browser.callTwoWay(msg);
    }
    add(request) {
        const msg = this.createMessage('layouts.add', v4(), request);
        return this._host.browser.callTwoWay(msg);
    }
    remove(request) {
        const msg = this.createMessage('layouts.remove', v4(), request);
        return this._host.browser.callTwoWay(msg);
    }
    observe(callback, matterId) {
        matterId = matterId !== null && matterId !== void 0 ? matterId : this._host.context.matterId;
        if (!matterId) {
            throw Error('MatterId is missing');
        }
        if (!callback) {
            throw Error('Callback is missing');
        }
        const request = {
            matterId: matterId
        };
        // Use the sessionId for the subscription to prevent multiple subscriptions per session
        const messageId = `layouts_${this._host.context.sessionId}`;
        const msg = this.createMessage('layouts.observe', messageId, request);
        // Create the subscription here
        this._host.browser.subscribe(msg, callback);
    }
    createMessage(operation, messageId, request) {
        const msg = {
            messageId: messageId,
            operation: operation,
            payload: request
        };
        return msg;
    }
}

class FilesApi {
    constructor(host) {
        this._host = host;
    }
    open(request) {
        const msg = this.createMessage('files.open', v4(), request);
        return this._host.browser.call(msg);
    }
    select(request) {
        const msg = this.createMessage('files.select', v4(), request);
        return this._host.browser.callTwoWay(msg);
    }
    getMany(request) {
        const msg = this.createMessage('files.getMany', v4(), request);
        return this._host.browser.callTwoWay(msg);
    }
    createMessage(operation, messageId, payload) {
        const msg = {
            messageId: messageId,
            operation: operation,
            payload: payload
        };
        return msg;
    }
}

class FirmApi {
    constructor(host) {
        this._host = host;
    }
    get() {
        const msg = this.createMessage('firm.get', v4());
        return this._host.browser.callTwoWay(msg);
    }
    update(request) {
        const msg = this.createMessage('firm.update', v4(), request);
        return this._host.browser.callTwoWay(msg);
    }
    observe(callback) {
        if (!callback) {
            throw Error('Callback is missing');
        }
        // Use the sessionId for the subscription to prevent multiple subscriptions per session
        const msg = {
            messageId: `firm_${this._host.context.sessionId}`,
            operation: 'firm.observe'
        };
        // Create the subscription here
        this._host.browser.subscribe(msg, callback);
    }
    createMessage(operation, messageId, payload) {
        const msg = {
            messageId: messageId,
            operation: operation,
            payload: payload
        };
        return msg;
    }
}

class FormsApi {
    constructor(host) {
        this._host = host;
    }
    open(request) {
        const msg = this.createMessage('forms.open', v4(), request);
        return this._host.browser.callTwoWay(msg);
    }
    createMessage(operation, messageId, payload) {
        const msg = {
            messageId: messageId,
            operation: operation,
            payload: payload
        };
        return msg;
    }
}

class CorrespondenceApi {
    constructor(host) {
        this._host = host;
    }
    email(request) {
        const msg = this.createMessage('correspondence.email', v4(), request);
        return this._host.browser.call(msg);
    }
    letter(request) {
        const msg = this.createMessage('correspondence.letter', v4(), request);
        return this._host.browser.call(msg);
    }
    form(request) {
        const msg = this.createMessage('correspondence.form', v4(), request);
        return this._host.browser.call(msg);
    }
    document(request) {
        const msg = this.createMessage('correspondence.document', v4(), request);
        return this._host.browser.call(msg);
    }
    createMessage(operation, messageId, request) {
        const msg = {
            messageId: messageId,
            operation: operation,
            payload: request
        };
        return msg;
    }
}

class StaffApi {
    constructor(host) {
        this._host = host;
    }
    get(staffId) {
        const request = {
            id: staffId
        };
        const msg = this.createMessage('staff.get', v4(), request);
        return this._host.browser.callTwoWay(msg);
    }
    all() {
        const msg = this.createMessage('staff.all', v4());
        return this._host.browser.callTwoWay(msg);
    }
    observe(callback) {
        // Use the sessionId for the subscription to prevent multiple subscriptions per session.
        const messageId = `staff_${this._host.context.sessionId}`;
        const msg = this.createMessage('staff.observe', messageId);
        // Wrap the callback so we can hide the StaffResponse from the user.
        const callbackWrapper = (response) => {
            callback(response.staff);
        };
        // Create the subscription here.
        this._host.browser.subscribe(msg, callbackWrapper);
    }
    createMessage(operation, messageId, request) {
        const msg = {
            messageId: messageId,
            operation: operation,
            payload: request
        };
        return msg;
    }
}

class CommunicateApi {
    constructor(host) {
        this._host = host;
    }
    createMessage(request) {
        const msg = {
            messageId: v4(),
            operation: 'communicate.createMessage',
            payload: request
        };
        return this._host.browser.call(msg);
    }
    sendMessage(request) {
        const msg = {
            messageId: v4(),
            operation: 'communicate.sendMessage',
            payload: request
        };
        return this._host.browser.call(msg);
    }
}

class RelationshipsApi {
    constructor(host) {
        this._host = host;
    }
    get(roleId) {
        const request = { roleId };
        const msg = this.createMessage('relationships.get', v4(), request);
        return this._host.browser.callTwoWay(msg);
    }
    add(request) {
        const msg = this.createMessage('relationships.add', v4(), request);
        return this._host.browser.callTwoWay(msg);
    }
    update(request) {
        const msg = this.createMessage('relationships.update', v4(), request);
        return this._host.browser.callTwoWay(msg);
    }
    remove(roleId, id) {
        const request = {
            id,
            roleId
        };
        const msg = this.createMessage('relationships.remove', v4(), request);
        return this._host.browser.callTwoWay(msg);
    }
    createMessage(operation, messageId, request) {
        const msg = {
            messageId: messageId,
            operation: operation,
            payload: request
        };
        return msg;
    }
}

class TasksApi {
    constructor(host) {
        this._host = host;
    }
    get(taskId) {
        const request = {
            id: taskId
        };
        const msg = this.createMessage('tasks.get', v4(), request);
        return this._host.browser.callTwoWay(msg);
    }
    all(matterId) {
        const request = {
            matterId: matterId
        };
        const msg = this.createMessage('tasks.all', v4(), request);
        return this._host.browser.callTwoWay(msg);
    }
    open(taskId) {
        if (!taskId) {
            throw Error('TaskId is missing');
        }
        const request = {
            id: taskId
        };
        const msg = this.createMessage('tasks.open', v4(), request);
        return this._host.browser.call(msg);
    }
    openNew(request) {
        const msg = this.createMessage('tasks.openNew', v4(), request);
        this._host.browser.call(msg);
    }
    create(request) {
        const msg = this.createMessage('tasks.create', v4(), request);
        return this._host.browser.callTwoWay(msg);
    }
    update(request) {
        const msg = this.createMessage('tasks.update', v4(), request);
        return this._host.browser.callTwoWay(msg);
    }
    delete(id) {
        const request = {
            id: id
        };
        const msg = this.createMessage('tasks.delete', v4(), request);
        return this._host.browser.callTwoWay(msg);
    }
    createMessage(operation, messageId, request) {
        const msg = {
            messageId: messageId,
            operation: operation,
            payload: request
        };
        return msg;
    }
}

class SubTasksApi {
    constructor(host) {
        this._host = host;
    }
    get(id, taskId) {
        const request = {
            id: id,
            taskId: taskId
        };
        const msg = this.createMessage('subTasks.get', v4(), request);
        return this._host.browser.callTwoWay(msg);
    }
    all(taskId) {
        const request = {
            taskId: taskId
        };
        const msg = this.createMessage('subTasks.all', v4(), request);
        return this._host.browser.callTwoWay(msg);
    }
    create(request) {
        const msg = this.createMessage('subTasks.create', v4(), request);
        return this._host.browser.callTwoWay(msg);
    }
    update(request) {
        const msg = this.createMessage('subTasks.update', v4(), request);
        return this._host.browser.callTwoWay(msg);
    }
    delete(id, taskId) {
        const request = {
            id: id,
            taskId: taskId
        };
        const msg = this.createMessage('subTasks.delete', v4(), request);
        return this._host.browser.callTwoWay(msg);
    }
    createMessage(operation, messageId, request) {
        const msg = {
            messageId: messageId,
            operation: operation,
            payload: request
        };
        return msg;
    }
}

class Subscriptions {
    constructor() {
        this._subscriptions = new Map();
    }
    add(messageId, callback) {
        this._subscriptions.set(messageId, this.convertCallbackType(callback));
        return messageId;
    }
    remove(messageId) {
        if (!this._subscriptions.has(messageId)) {
            throw new Error(`Subscription ${messageId} is not registered`);
        }
        this._subscriptions.delete(messageId);
    }
    get(messageId) {
        return this._subscriptions.get(messageId);
    }
    convertCallbackType(callback) {
        return (payload) => {
            callback(payload);
        };
    }
}

class MemosApi {
    constructor(host) {
        this._host = host;
    }
    openNew(request) {
        const msg = this.createMessage('memos.openNew', v4(), request);
        this._host.browser.call(msg);
    }
    createMessage(operation, messageId, request) {
        const msg = {
            messageId: messageId,
            operation: operation,
            payload: request
        };
        return msg;
    }
}

class MSWebView {
    constructor(subscriptions) {
        var _a;
        this._webView = (_a = window === null || window === void 0 ? void 0 : window.chrome) === null || _a === void 0 ? void 0 : _a.webview;
        this._subscriptions = subscriptions;
    }
    /** Register message event from native environment. */
    init() {
        this._webView.addEventListener('message', (event) => this.handleMessage(event));
    }
    /** Post a message and forget. */
    call(msg) {
        var _a;
        if (!msg) {
            throw Error('Message not provided');
        }
        msg.messageId = (_a = msg.messageId) !== null && _a !== void 0 ? _a : v4();
        this.postMessage(msg);
    }
    /** Post specified message and expect a response. */
    callTwoWay(msg) {
        var _a;
        if (!msg) {
            throw Error('Message not provided');
        }
        // Set messageId if it's missing
        const messageId = (_a = msg.messageId) !== null && _a !== void 0 ? _a : v4();
        msg.messageId = messageId;
        return new Promise((resolve, reject) => {
            const callback = (response) => {
                var _a;
                // Unsubscribe when the response comes back
                this._subscriptions.remove(messageId);
                // Resolve with response data on success
                if (!response.error) {
                    // const payload = JSON.parse(response.payload) as T;
                    const payload = response.payload;
                    resolve(payload);
                    return;
                }
                // Throw an error on failed
                reject(new Error((_a = response.error) !== null && _a !== void 0 ? _a : `An error occurred handling response for message operation: ${msg.operation}, message ${JSON.stringify(msg)}`));
            };
            // Subscribe the message to the specified callback
            this._subscriptions.add(messageId, callback);
            // Post message
            this.postMessage(msg);
        });
    }
    /** Subscribe with the specified type. */
    subscribe(msg, callback) {
        const callbackWrapper = (msg) => {
            if (msg.error) {
                throw Error(msg.error);
            }
            // const payload = JSON.parse(msg.payload) as T;
            const payload = msg.payload;
            callback(payload);
        };
        // Remove existing subscription first incase the same message is subscribed to more than once
        if (this._subscriptions.get(msg.messageId)) {
            this._subscriptions.remove(msg.messageId);
        }
        // Subscribe the message to the specified callback
        this._subscriptions.add(msg.messageId, callbackWrapper);
        // Post message
        this.postMessage(msg);
    }
    postMessage(msg) {
        // Note: we aren't doing this anymore
        // Make sure we send the payload as a string so we aren't dealing with JObjects in the native code
        // if (!(msg.payload instanceof String)) {
        //   msg.payload = JSON.stringify(msg.payload);
        // }
        this._webView.postMessage(msg);
    }
    /** Handle messages from Smokeball. */
    handleMessage(event) {
        const msg = event.data;
        const messageId = msg.messageId;
        const messageHandler = this._subscriptions.get(messageId);
        if (!messageHandler) {
            // Nothing to do, handler does not exist
            return;
        }
        messageHandler(msg);
    }
}

class SmokeballNative {
    constructor() {
        this._version = '1.0.42';
        this._subscriptions = new Subscriptions();
        this._msWebView = new MSWebView(this._subscriptions);
    }
    /** Check if we are in Smokeball Native. */
    static inApp() {
        var _a;
        return (_a = window === null || window === void 0 ? void 0 : window.chrome) === null || _a === void 0 ? void 0 : _a.webview;
    }
    /** Initialize the session and set the context. */
    init({ clientId } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            // Already initialized, do nothing
            if (this._context) {
                return;
            }
            // Initialize MSWebView
            this._msWebView.init();
            // Initialize context
            const msg = {
                messageId: v4(),
                operation: 'system.init',
                payload: { clientId }
            };
            const response = yield this._msWebView.callTwoWay(msg);
            // Set context
            this._context = response;
            // Initialize APIs
            this._host = new HostApi(this);
            this._auth = new AuthApi(this);
            this._matters = new MattersApi(this);
            this._matterItems = new MatterItemsApi(this);
            this._roles = new RolesApi(this);
            this._contacts = new ContactsApi(this);
            this._layouts = new LayoutsApi(this);
            this._files = new FilesApi(this);
            this._firm = new FirmApi(this);
            this._forms = new FormsApi(this);
            this._correspondence = new CorrespondenceApi(this);
            this._staff = new StaffApi(this);
            this._communicate = new CommunicateApi(this);
            this._relationships = new RelationshipsApi(this);
            this._tasks = new TasksApi(this);
            this._subTasks = new SubTasksApi(this);
            this._memos = new MemosApi(this);
        });
    }
    /** @returns the version of @smokeballdev/smokeball-client-sdk */
    get version() {
        return this._version;
    }
    /** Returns the context. */
    get context() {
        return this._context;
    }
    /** Returns the host API. */
    get host() {
        if (this._host == null) {
            throw Error('Host API is not available. Did you call init?');
        }
        return this._host;
    }
    /** Returns the auth API. */
    get auth() {
        return this._auth;
    }
    /** Returns the matters API. */
    get matters() {
        if (this._matters == null) {
            throw Error('Matters API is not available. Did you call init?');
        }
        return this._matters;
    }
    /** Returns the matter items API. */
    get matterItems() {
        if (this._matterItems == null) {
            throw Error('MatterItems API is not available. Did you call init?');
        }
        return this._matterItems;
    }
    /** Returns the roles API. */
    get roles() {
        if (this._roles == null) {
            throw Error('Roles API is not available. Did you call init?');
        }
        return this._roles;
    }
    /** Returns the contacts API. */
    get contacts() {
        if (this._contacts == null) {
            throw Error('Contacts API is not available. Did you call init?');
        }
        return this._contacts;
    }
    /** Returns the layouts API. */
    get layouts() {
        if (this._layouts == null) {
            throw Error('Layouts API is not available. Did you call init?');
        }
        return this._layouts;
    }
    /** Returns the files API. */
    get files() {
        if (this._files == null) {
            throw Error('Files API is not available. Did you call init?');
        }
        return this._files;
    }
    /** Returns the firm API. */
    get firm() {
        if (this._firm == null) {
            throw Error('Firm API is not available. Did you call init?');
        }
        return this._firm;
    }
    /** Returns the forms API. */
    get forms() {
        if (this._forms == null) {
            throw Error('Forms API is not available. Did you call init?');
        }
        return this._forms;
    }
    /** Returns the correspondence API. */
    get correspondence() {
        if (this._correspondence == null) {
            throw Error('Correspondence API is not available. Did you call init?');
        }
        return this._correspondence;
    }
    /** Returns the staff API. */
    get staff() {
        if (this._staff == null) {
            throw Error('Staff API is not available. Did you call init?');
        }
        return this._staff;
    }
    /** Returns the communicate API. */
    get communicate() {
        if (this._communicate == null) {
            throw Error('Communicate API is not available. Did you call init?');
        }
        return this._communicate;
    }
    /** Returns the relationships API */
    get relationships() {
        if (this._relationships == null) {
            throw Error('Relationships API is not available. Did you call init?');
        }
        return this._relationships;
    }
    /** Returns the tasks API. */
    get tasks() {
        if (this._tasks == null) {
            throw Error('Tasks API is not available. Did you call init?');
        }
        return this._tasks;
    }
    /** Returns the subTasks API. */
    get subTasks() {
        if (this._subTasks == null) {
            throw Error('SubTasks API is not available. Did you call init?');
        }
        return this._subTasks;
    }
    /** Returns the memos API. */
    get memos() {
        if (this._memos == null) {
            throw Error('Memos API is not available. Did you call init?');
        }
        return this._memos;
    }
    /** Returns the browser component. */
    get browser() {
        return this._msWebView;
    }
    /** Returns the subscriptions component. */
    get subscriptions() {
        return this._subscriptions;
    }
}

const allowedHosts = [
    'http://localhost:9001',
    'https://dev-billing.smokeball.com',
    'https://rc-billing.smokeball.com',
    'https://qa-billing.smokeball.com',
    'https://billing.smokeball.com',
    'https://dev-billing.smokeball.com.au',
    'https://rc-billing.smokeball.com.au',
    'https://qa-billing.smokeball.com.au',
    'https://billing.smokeball.com.au',
    'https://dev-billing.smokeball.co.uk',
    'https://rc-billing.smokeball.co.uk',
    'https://qa-billing.smokeball.co.uk',
    'https://billing.smokeball.co.uk',
    'https://dev-app.smokeball.com',
    'https://rc-app.smokeball.com',
    'https://qa-app.smokeball.com',
    'https://app.smokeball.com',
    'https://dev-app.smokeball.com.au',
    'https://rc-app.smokeball.com.au',
    'https://qa-app.smokeball.com.au',
    'https://app.smokeball.com.au',
    'https://dev-app.smokeball.co.uk',
    'https://rc-app.smokeball.co.uk',
    'https://qa-app.smokeball.co.uk',
    'https://app.smokeball.co.uk'
];
class WebView {
    constructor(subscriptions) {
        this._webView = window === null || window === void 0 ? void 0 : window.top;
        this._subscriptions = subscriptions;
    }
    /** Register message event from native environment. */
    init() {
        window.onmessage = (iframeMessage) => __awaiter(this, void 0, void 0, function* () {
            const isAllowed = () => {
                if (allowedHosts.includes(iframeMessage.origin.toLowerCase())) {
                    return true;
                }
                console.warn(`Refusing to allow onmessage. Unknown host ${iframeMessage.origin}`);
                return false;
            };
            if (this._webView && iframeMessage.data) {
                if (isAllowed()) {
                    this.handleMessage(iframeMessage);
                }
            }
        });
    }
    /** Post a message and forget. */
    call(msg) {
        var _a;
        if (!msg) {
            throw Error('Message not provided');
        }
        msg.messageId = (_a = msg.messageId) !== null && _a !== void 0 ? _a : v4();
        this.postMessage(msg);
    }
    /** Post specified message and expect a response. */
    callTwoWay(msg) {
        var _a;
        if (!msg) {
            throw Error('Message not provided');
        }
        // Set messageId if it's missing
        const messageId = (_a = msg.messageId) !== null && _a !== void 0 ? _a : v4();
        msg.messageId = messageId;
        return new Promise((resolve, reject) => {
            const callback = (response) => {
                var _a;
                // Unsubscribe when the response comes back
                this._subscriptions.remove(messageId);
                // Resolve with response data on success
                if (!response.error) {
                    // const payload = JSON.parse(response.payload) as T;
                    const payload = response.payload;
                    resolve(payload);
                    return;
                }
                // Throw an error on failed
                reject(new Error((_a = response.error) !== null && _a !== void 0 ? _a : `An error occurred handling response for message operation: ${msg.operation}, message ${JSON.stringify(msg)}`));
            };
            // Subscribe the message to the specified callback
            this._subscriptions.add(messageId, callback);
            // Post message
            this.postMessage(msg);
        });
    }
    /** Subscribe with the specified type. */
    subscribe(msg, callback) {
        const callbackWrapper = (msg) => {
            if (msg.error) {
                throw Error(msg.error);
            }
            // const payload = JSON.parse(msg.payload) as T;
            const payload = msg.payload;
            callback(payload);
        };
        // Remove existing subscription first incase the same message is subscribed to more than once
        if (this._subscriptions.get(msg.messageId)) {
            this._subscriptions.remove(msg.messageId);
        }
        // Subscribe the message to the specified callback
        this._subscriptions.add(msg.messageId, callbackWrapper);
        // Post message
        this.postMessage(msg);
    }
    postMessage(msg) {
        // Note: we aren't doing this anymore
        // Make sure we send the payload as a string so we aren't dealing with JObjects in the native code
        // if (!(msg.payload instanceof String)) {
        //   msg.payload = JSON.stringify(msg.payload);
        // }
        const hostURL = new URL(document.referrer);
        const origin = hostURL.origin;
        const isAllowed = () => {
            if (allowedHosts.includes(origin)) {
                return true;
            }
            console.warn(`Refusing to allow postMessage. Unknown origin ${origin}`);
            return false;
        };
        if (isAllowed()) {
            this._webView.postMessage(msg, document.referrer);
        }
    }
    /** Handle messages from Smokeball. */
    handleMessage(event) {
        const msg = event.data;
        const messageId = msg.messageId;
        const messageHandler = this._subscriptions.get(messageId);
        if (!messageHandler) {
            // Nothing to do, handler does not exist
            return;
        }
        messageHandler(msg);
    }
}

class SmokeballWeb {
    constructor() {
        this._version = '1.0.42';
        this._subscriptions = new Subscriptions();
        this._webView = new WebView(this._subscriptions);
    }
    /** Check if we are in a web client. */
    static inWeb() {
        var _a, _b;
        return (((_a = window === null || window === void 0 ? void 0 : window.navigator) === null || _a === void 0 ? void 0 : _a.appCodeName) === 'Mozilla' &&
            !!((_b = window === null || window === void 0 ? void 0 : window.location) === null || _b === void 0 ? void 0 : _b.hostname) &&
            !!document.referrer &&
            !!(window === null || window === void 0 ? void 0 : window.top) &&
            allowedHosts.some((host) => 
            // Wont work if the page reloads or navigates like NextJS does.
            document.referrer.startsWith(host) ||
                // Only supported in Chromium
                (document.location.ancestorOrigins &&
                    document.location.ancestorOrigins[0].startsWith(host))));
    }
    /** Initialize the session and set the context. */
    init({ clientId } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            // Already initialized, do nothing
            if (this._context) {
                return;
            }
            // Initialize MSWebView
            this._webView.init();
            // Initialize context
            const msg = {
                messageId: v4(),
                operation: 'system.init',
                payload: { clientId }
            };
            const response = yield this._webView.callTwoWay(msg);
            // Set context
            this._context = response;
            // Initialize APIs
            this._host = new HostApi(this);
            this._auth = new AuthApi(this);
            this._matters = new MattersApi(this);
            this._matterItems = new MatterItemsApi(this);
            this._roles = new RolesApi(this);
            this._contacts = new ContactsApi(this);
            this._layouts = new LayoutsApi(this);
            this._files = new FilesApi(this);
            this._firm = new FirmApi(this);
            this._forms = new FormsApi(this);
            this._correspondence = new CorrespondenceApi(this);
            this._staff = new StaffApi(this);
            this._communicate = new CommunicateApi(this);
            this._relationships = new RelationshipsApi(this);
            this._tasks = new TasksApi(this);
            this._subTasks = new SubTasksApi(this);
            this._memos = new MemosApi(this);
        });
    }
    /** @returns the version of @smokeballdev/smokeball-client-sdk */
    get version() {
        return this._version;
    }
    /** Returns the context. */
    get context() {
        return this._context;
    }
    /** Returns the host API. */
    get host() {
        if (this._host == null) {
            throw Error('Host API is not available. Did you call init?');
        }
        return this._host;
    }
    /** Returns the auth API. */
    get auth() {
        return this._auth;
    }
    /** Returns the matters API. */
    get matters() {
        if (this._matters == null) {
            throw Error('Matters API is not available. Did you call init?');
        }
        return this._matters;
    }
    /** Returns the matter items API. */
    get matterItems() {
        if (this._matterItems == null) {
            throw Error('MatterItems API is not available. Did you call init?');
        }
        return this._matterItems;
    }
    /** Returns the roles API. */
    get roles() {
        if (this._roles == null) {
            throw Error('Roles API is not available. Did you call init?');
        }
        return this._roles;
    }
    /** Returns the contacts API. */
    get contacts() {
        if (this._contacts == null) {
            throw Error('Contacts API is not available. Did you call init?');
        }
        return this._contacts;
    }
    /** Returns the layouts API. */
    get layouts() {
        if (this._layouts == null) {
            throw Error('Layouts API is not available. Did you call init?');
        }
        return this._layouts;
    }
    /** Returns the files API. */
    get files() {
        if (this._files == null) {
            throw Error('Files API is not available. Did you call init?');
        }
        return this._files;
    }
    /** Returns the firm API. */
    get firm() {
        if (this._firm == null) {
            throw Error('Firm API is not available. Did you call init?');
        }
        return this._firm;
    }
    /** Returns the forms API. */
    get forms() {
        if (this._forms == null) {
            throw Error('Forms API is not available. Did you call init?');
        }
        return this._forms;
    }
    /** Returns the correspondence API. */
    get correspondence() {
        if (this._correspondence == null) {
            throw Error('Correspondence API is not available. Did you call init?');
        }
        return this._correspondence;
    }
    /** Returns the staff API. */
    get staff() {
        if (this._staff == null) {
            throw Error('Staff API is not available. Did you call init?');
        }
        return this._staff;
    }
    /** Returns the communicate API. */
    get communicate() {
        if (this._communicate == null) {
            throw Error('Communicate API is not available. Did you call init?');
        }
        return this._communicate;
    }
    /** Returns the relationships API */
    get relationships() {
        if (this._relationships == null) {
            throw Error('Relationships API is not available. Did you call init?');
        }
        return this._relationships;
    }
    /** Returns the tasks API. */
    get tasks() {
        if (this._tasks == null) {
            throw Error('Tasks API is not available. Did you call init?');
        }
        return this._tasks;
    }
    /** Returns the memos API. */
    get memos() {
        if (this._memos == null) {
            throw Error('Memos API is not available. Did you call init?');
        }
        return this._memos;
    }
    /** Returns the subTasks API. */
    get subTasks() {
        if (this._subTasks == null) {
            throw Error('SubTasks API is not available. Did you call init?');
        }
        return this._subTasks;
    }
    /** Returns the browser component. */
    get browser() {
        return this._webView;
    }
    /** Returns the subscriptions component. */
    get subscriptions() {
        return this._subscriptions;
    }
}

class SmokeballClientSdk {
    /**
     * Creates the entry point to the Smokeball Client Sdk.
     * @example
     * ```
     * const sdk = SmokeballClientSdk.get();
     * if (sdk != null) {
     *   // Interoperability with Smokeball is possible.
     * }
     * ```
     *
     * @returns
     * sdk instance if the Smokeball app is loaded and interoperability is possible.
     *
     * null when the Smokeball app is not loaded.
     */
    static get() {
        let sdk = null;
        if (SmokeballNative.inApp()) {
            console.log('Smokeball Native Client Sdk 1.0.42');
            sdk = new SmokeballNative();
        }
        else if (SmokeballWeb.inWeb()) {
            console.log('Smokeball Web Client Sdk 1.0.42');
            sdk = new SmokeballWeb();
        }
        if (window === null || window === void 0 ? void 0 : window.getSmokeballClientSdkMock) {
            console.log('Smokeball Mock Client Sdk 1.0.42');
            const getMock = window === null || window === void 0 ? void 0 : window.getSmokeballClientSdkMock;
            const mock = typeof getMock === 'function' ? getMock({ sdk }) : getMock;
            return mock;
        }
        return sdk;
    }
}
/**
 * Creates the entry point to the Smokeball Client Sdk.
 * @example
 * ```
 * const sdk = SmokeballClientSdk.get();
 * if (sdk != null) {
 *   // Interoperability with Smokeball is possible.
 * }
 * ```
 *
 * @returns
 * sdk instance if the Smokeball app is loaded and interoperability is possible.
 *
 * null when the Smokeball app is not loaded.
 */
function get() {
    if (SmokeballNative.inApp()) {
        console.log('Smokeball Native Client Sdk v0.1');
        return new SmokeballNative();
    }
    if (SmokeballWeb.inWeb()) {
        console.log('Smokeball Web Client Sdk v0.1');
        return new SmokeballWeb();
    }
    return null;
}
var index = { SmokeballClientSdk };

export { SmokeballClientSdk, index as default, get, host };
